import { useLocation } from 'react-router-dom'
import { type Role } from '../types/index.js'

export const getRoleFromQueryString = (search: string): string | null => new URLSearchParams(search).get('role')

export const useRoleParamFromUrl = (): Role => {
  const defaultRole: Role = 'consumer-receiver'

  const location = useLocation()
  const role = getRoleFromQueryString(location.search) ?? defaultRole

  if (['consumer-receiver', 'consumer-shipper'].includes(role)) {
    return role as Role
  }

  return role === 'shipper' ? 'consumer-shipper' : defaultRole
}
